import z from 'zod';
import { setlists } from '@/db/schema';
import { SONG_KEYS } from '@/lib/song/transpose';
import { queryParamsSchema } from '../core/schemas';

const setlistColumns = Object.keys(setlists ?? {}) as [
  keyof typeof setlists,
  ...(keyof typeof setlists)[],
];

export const setlistSchemas = {
  queryParams: queryParamsSchema.extend({
    orderBy: z
      .enum(
        setlistColumns,
        'Campo inválido! Deve ser um dos seguintes: ' + setlistColumns.join(', '),
      )
      .optional(),
    id: z.string().optional(),
    name: z.string().optional(),
    userId: z.string().optional(),
    /** `true` = só os repertórios do usuário logado. */
    mine: z.string().optional(),
    /** `true` = com data de hoje em diante (do mais próximo ao mais distante). */
    upcoming: z.string().optional(),
    isActive: z.string().optional(),
    createdAt: z.coerce.date().optional(),
    createdAtFrom: z.coerce.date().optional(),
    createdAtTo: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    updatedAtFrom: z.coerce.date().optional(),
    updatedAtTo: z.coerce.date().optional(),
  }),
  create: z.object({
    name: z.string('Nome é obrigatório!').min(1, 'Campo obrigatório!'),
    scheduledAt: z.string('Data da celebração inválida!').nullish(),
    /** Só admin escolhe o responsável; para `user` vale sempre o próprio. */
    userId: z.uuid('Responsável inválido!').optional(),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional().default(true),
  }),
  update: z.object({
    name: z.string('Nome é obrigatório!').min(1, 'Campo obrigatório!').optional(),
    scheduledAt: z.string('Data da celebração inválida!').nullish(),
    userId: z.uuid('Responsável inválido!').optional(),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional(),
  }),
  /** Corpo do `PUT /setlists/:id/songs`: a lista inteira, na ordem final. */
  songs: z.object({
    items: z
      .array(
        z.object({
          songId: z.uuid('Música inválida!'),
          /** Tom no repertório; ausente = tom original da música. */
          key: z.enum(SONG_KEYS, 'Tom inválido!').nullish(),
        }),
      )
      .max(200, 'Máximo de 200 músicas por repertório'),
  }),
};

export type SetlistQueryParams = z.infer<typeof setlistSchemas.queryParams>;
export type CreateSetlistSchema = z.input<typeof setlistSchemas.create>;
export type UpdateSetlistSchema = z.infer<typeof setlistSchemas.update>;
export type SetlistSongsSchema = z.infer<typeof setlistSchemas.songs>;

/** Filtros aceitos por `SetlistRepository.findAll` (`mine` já virou `userId` no serviço). */
export type SetlistListFilters = Partial<
  Pick<SetlistQueryParams, 'id' | 'name' | 'userId' | 'upcoming' | 'isActive' | 'search'>
>;
